import { faChevronLeft, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { useMemo, useState } from 'react';
import { Icon, IconButton } from '@/components/ui';
import useHeaderContent from '@/hooks/use-header-content';
import { useResolveThemeColor } from '@/hooks/use-resolve-theme-color';

const AnnouncementBanner = () => {
  const resolveThemeColor = useResolveThemeColor();
  const headerContent = useHeaderContent();
  const messages = useMemo(
    () => (headerContent.announcementBar?.messages ?? []).filter(Boolean),
    [headerContent.announcementBar?.messages],
  );
  const [activeIndex, setActiveIndex] = useState(0);

  if (messages.length === 0) {
    return null;
  }

  const textColor = resolveThemeColor(headerContent.announcementBarTextColor ?? 'content1');
  const background = resolveThemeColor(headerContent.announcementBarBackground ?? 'primary');
  const currentMessage = messages[activeIndex % messages.length];
  const hasMultipleMessages = messages.length > 1;

  const showPrevious = () => {
    setActiveIndex(index => (index - 1 + messages.length) % messages.length);
  };

  const showNext = () => {
    setActiveIndex(index => (index + 1) % messages.length);
  };

  return (
    <div className="flex min-h-10 w-full items-center @lg:h-10" style={{ background }}>
      <div className="container mx-auto flex min-h-10 w-full items-center px-3 py-1.5 @lg:px-5 @lg:py-0">
        <div className="flex w-10 shrink-0 justify-start">
          {hasMultipleMessages ? (
            <IconButton
              aria-label="Previous announcement"
              variant="light"
              size="sm"
              className="min-h-8 min-w-8 bg-transparent"
              onPress={showPrevious}
            >
              <Icon icon={faChevronLeft} size="sm" style={{ color: textColor }} />
            </IconButton>
          ) : null}
        </div>
        <p
          className="flex-1 px-2 text-center text-xs font-medium @lg:text-sm"
          style={{ color: textColor }}
        >
          {currentMessage}
        </p>
        <div className="flex w-10 shrink-0 justify-end">
          {hasMultipleMessages ? (
            <IconButton
              aria-label="Next announcement"
              variant="light"
              size="sm"
              className="min-h-8 min-w-8 bg-transparent"
              onPress={showNext}
            >
              <Icon icon={faChevronRight} size="sm" style={{ color: textColor }} />
            </IconButton>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
